import { render, staticRenderFns } from "./carCreateFeeAdd.vue?vue&type=template&id=1fca0b24&scoped=true"
import script from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeAdd.vue?vue&type=style&index=0&id=1fca0b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca0b24",
  null
  
)

export default component.exports